<template>
  <div>
    <section class="SubMenu tw-bg-gradient2-lr tw-py-6">
      <div class="ns-container">
        <h1 class="heading-white tw-text-center">
          Stats
        </h1>
      </div>
    </section>

    <section class="search">
      <div class="ns-container">
        <div class="row">
          <div>
            <div class="panel panel-default">
              <div class="panel-heading">
                Stats (as of {{ stats.info.cached_at }})
                <a
                  class="btn btn-default"
                  @click="refresh"
                >
                  <i
                    class="fas fa-sync-alt"
                    aria-hidden="true"
                  />
                </a>
              </div>

              <div class="panel-body">
                <pre>{{ stats.members }}</pre>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      stats: {
        members: {},
        info: {
          cached_at: null,
        },
      },
    };
  },

  created() {
    this.$store.set('general/loading', true);
    this.loadStats();
  },

  methods: {
    loadStats() {
      this.$http.get('/api/admin/stats').then((response) => {
        this.$store.set('general/loading', false);
        // console.log(response.data);
        this.stats = response.data;
      });
    },

    refresh() {
      Bus.$emit('refresh');
    },
  },
};
</script>
